import { ShieldCheck, RefreshCw, FileDown, CheckCircle2, AlertTriangle, ChevronDown, ChevronRight } from "lucide-react";
import { FILE_ORDER, FILE_LABELS } from "./constants";

export default function ValidateTab({ validate, onlyInvalid, setOnlyInvalid, expandedFiles, setExpandedFiles, onReload, onExport }) {
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <p className="text-xs text-slate-400 flex items-center gap-1.5"><ShieldCheck size={13} className="text-cyan-400" /> Sprawdzenie kompletności rekordów (TERC/SIMC/współrzędne/NIP) przed wysłaniem do UKE.</p>
        <div className="flex gap-2 items-center">
          <label className="flex items-center gap-1.5 text-xs text-slate-400"><input type="checkbox" checked={onlyInvalid} onChange={(e) => setOnlyInvalid(e.target.checked)} data-testid="pituke-validate-onlyinvalid" /> Tylko z brakami</label>
          <button onClick={onReload} className="bg-slate-700 hover:bg-slate-600 text-white rounded px-3 py-1.5 text-xs flex items-center gap-1.5"><RefreshCw size={13} /> Sprawdź ponownie</button>
          <button onClick={onExport} data-testid="pituke-validate-export" className="bg-amber-600 hover:bg-amber-500 text-white rounded px-3 py-1.5 text-xs flex items-center gap-1.5"><FileDown size={13} /> Pobierz braki (CSV)</button>
        </div>
      </div>
      {!validate ? <div className="text-slate-500">Ładowanie…</div> : (
        <div className="space-y-2">
          {FILE_ORDER.filter((key) => !onlyInvalid || (validate[key]?.invalid > 0)).map((key) => {
            const v = validate[key]; if (!v) return null;
            const ok = v.invalid === 0;
            const open = !!expandedFiles[key];
            const toggle = () => setExpandedFiles((s) => ({ ...s, [key]: !s[key] }));
            return (
              <div key={key} className="rounded-lg border border-slate-700 bg-slate-800/40 p-3" data-testid={`pituke-valid-${key}`}>
                <button onClick={ok ? undefined : toggle} data-testid={`pituke-valid-toggle-${key}`} className={`w-full flex items-center justify-between ${ok ? "cursor-default" : "cursor-pointer"}`}>
                  <div className="flex items-center gap-2 font-medium text-white">
                    {!ok && (open ? <ChevronDown size={14} className="text-amber-400" /> : <ChevronRight size={14} className="text-amber-400" />)}
                    {ok ? <CheckCircle2 size={15} className="text-emerald-400" /> : <AlertTriangle size={15} className="text-amber-400" />}
                    {FILE_LABELS[key]}
                  </div>
                  <span className={`text-xs font-mono ${ok ? "text-emerald-400" : "text-amber-400"}`}>{ok ? `${v.total} OK` : `${v.invalid} / ${v.total} z brakami`}</span>
                </button>
                {!ok && open && (
                  <div className="mt-2 max-h-32 overflow-y-auto text-[11px] space-y-0.5" data-testid={`pituke-valid-problems-${key}`}>
                    {v.problems.map((p, i) => (
                      <div key={i} className="flex items-center gap-2 text-slate-400"><span className="font-mono text-slate-300">{p.id}</span><span className="text-amber-400">brak: {p.missing.join(", ")}</span></div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
